<div class="h-30"></div>
<form>
  <div class="form-fields">
    <mat-label>{{'planNameText'|translate:translations}}</mat-label>
    <mat-form-field appearance="outline" floatLabel="always">
      <input matInput class="form-control-textbox" [(ngModel)]="planDetails.planName" name="planname" />
    </mat-form-field>
    @if (isSubmitted && (planDetails.planName === null || planDetails.planName === undefined || planDetails.planName === '')) {
      <mat-error class="validation-error">
        {{'planNameErrorText'|translate:translations}}
      </mat-error>
    }
  </div>

  <div class="form-fields">
    <mat-label>{{'whenAreYouGoingToDoItText'|translate:translations}}</mat-label>
    <mat-form-field>
      <mat-select placeholder="Select" name="courseprograms" [(ngModel)]="planDetails.whenAreYouGoingToDoIt" (ngModelChange)="onPlanExecutionDurationChange()">
        @for (item of planAndReminderSchedule; track item) {
          <mat-option [value]="item.id">
            {{ item.description }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="form-fields" [hidden]="!planDetails.showPlanSpecificDateField">
    <mat-label>{{'specifyDate'|translate:translations}}</mat-label>
    <mat-form-field appearance="outline" floatLabel="always">
      <input matInput [matDatepicker]="dp5" [(ngModel)]="planDetails.planSpecificDate" name="planspecificdate" placeholder="DD/MM/YYYY">
      <mat-datepicker-toggle matIconSuffix [for]="dp5"></mat-datepicker-toggle>
      <mat-datepicker #dp5></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="form-fields">
    <mat-label>{{'whatAreYouGoingToDoText'|translate:translations}}</mat-label>
    <mat-form-field appearance="outline" floatLabel="always">
      <textarea matInput class="form-control-textbox" [(ngModel)]="planDetails.whatAreYouGoingToDo" name="whatAreYouGoingToDo" [cols]="colNums" [rows]="rowNums"></textarea>
    </mat-form-field>
    @if (isSubmitted && (planDetails.whatAreYouGoingToDo === null || planDetails.whatAreYouGoingToDo === undefined || planDetails.whatAreYouGoingToDo === '')) {
      <mat-error class="validation-error">
        {{'globalFieldRequired'|translate:translations}}
      </mat-error>
    }
  </div>

  <div class="form-fields">
    <mat-label>{{'problemsText'|translate:translations}}</mat-label>
    <mat-form-field appearance="outline" floatLabel="always">
      <textarea matInput class="form-control-textbox" [(ngModel)]="planDetails.difficultiesAndSolutions" name="difficultiesAndSolutions" [cols]="colNums" [rows]="rowNums"></textarea>
    </mat-form-field>
  </div>

  <div class="form-fields">
    <mat-label>{{'finalPlanText'|translate:translations}}</mat-label>
    <mat-form-field appearance="outline" floatLabel="always">
      <textarea matInput class="form-control-textbox" [(ngModel)]="planDetails.finalPlan" name="finalPlan" [cols]="colNums" [rows]="rowNums"></textarea>
    </mat-form-field>
  </div>

  <div class="form-fields">
    <div class="plan-checklist">
      <span><strong>{{'planCheckListText'|translate:translations}}</strong></span><br>
      <span>{{'plannedTaskIsText'|translate:translations}}</span>
      <div class="mb-10"></div>

      @for (item of planCheckListItems; track item) {
        <div>
          <label>
            <input type="checkbox" [value]="item.id" (change)="onCheckboxChange($event, item.id)" [checked]="isItemChecked(item,planDetails.planChecklist)" [name]="item.id" />
            {{ item.description }}
          </label>
        </div>
      }
    </div>
  </div>

  <div class="mb-20"></div>

  <div class="form-fileds">
    <div class="plan-reminder">
      <span><img src="assets/reminder-bell.svg" class="reminder-bell"></span>
      <span class="set-reminder-text" (click)="openReminderBox()">{{'setReminderText'|translate:translations}}</span>
    </div>
  </div>

  <div class="form-fields" [hidden]="!planDetails.showReminderDiv">
    <div class="reminder-container">
      <span class="reminder-container-heading">
        <strong>{{'setAlertsText'|translate:translations}}</strong>
        <strong><span (click)="closeReminderDiv()">X</span></strong>
      </span>
      <br>
        <div class="h-30"></div>

        <fieldset>
          <mat-form-field>
            <mat-label>{{'frequencyText'|translate:translations}}</mat-label>
            <mat-select placeholder="Select" name="frequency" [(ngModel)]="planDetails.reminderFrequency" (selectionChange)="onReminderDropDownChange()" (ngModelChange)="onReminderDropDownChange()">
              @for (item of planAndReminderSchedule; track item) {
                <mat-option [value]="item.id">
                  {{ item.description }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" class="timepicker-control plan-timepicker">
            <mat-label>{{'reminderTimeText'|translate:translations}}</mat-label>
            <input matInput hidden="true" />
            <ngx-timepicker-field [defaultTime]="'10:10 am'" style="border-bottom: 0px;" [minutesGap]="15" [(ngModel)]="planDetails.reminderTime" name="reminderTime"></ngx-timepicker-field>
          </mat-form-field>
          @if (isSubmitted && planDetails.reminderFrequency != 0 && (planDetails.reminderTime == null || planDetails.reminderTime == '')) {
            <mat-error>
              {{'reminderTimeErrorText'|translate:translations}}
            </mat-error>
          }
        </fieldset>

        <mat-form-field [hidden]="!planDetails.showReminderDayOfWeek">
          <mat-label>{{'dayOfWeekText'|translate:translations}}</mat-label>
          <mat-select placeholder="Select" name="dayofweek" [(ngModel)]="planDetails.reminderWeeklyDayOfWeek">
            @for (item of daysOfWeek; track item) {
              <mat-option [value]="item.id">
                {{ item.description }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (isSubmitted && planDetails.reminderFrequency == 4 && (planDetails.reminderWeeklyDayOfWeek == 0)) {
          <mat-error>
            {{'dayOfWeekErrorText'|translate:translations}}
          </mat-error>
        }

        <mat-form-field [hidden]="!planDetails.showReminderDateOfMonth">
          <mat-label>{{'dateOfMonthText'|translate:translations}}</mat-label>
          <mat-select placeholder="Select" name="dateofmonth" [(ngModel)]="planDetails.reminderMonthlyDate">
            @for (item of datesOfMonth; track item) {
              <mat-option [value]="item">
                {{ item }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" [hidden]="!planDetails.showReminderSpecificDate">
          <mat-label>{{'specifyDate'|translate:translations}}</mat-label>
          <input matInput [matDatepicker]="dp6" [(ngModel)]="planDetails.reminderSpecificDate" name="reminderspecificDate" placeholder="DD/MM/YYYY">
          <mat-datepicker-toggle matIconSuffix [for]="dp6"></mat-datepicker-toggle>
          <mat-datepicker #dp6></mat-datepicker>
        </mat-form-field>

      </div>
    </div>

  </form>
  <div class="mb-30"></div>
